'use client';

import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  titleClassName?: string;
  /** The page's own title is an h1 where the layout gives it none (the space pages); the default keeps the h2 the personal pages ship. */
  titleAs?: 'h1' | 'h2';
  /** Escape hatch for a title that takes focus after an action (id + tabIndex), spread onto the heading. */
  titleProps?: HTMLAttributes<HTMLHeadingElement>;
}

export function PageHeader({ title, description, actions, className = '', titleClassName, titleAs: Title = 'h2', titleProps }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between', className)}>
      <div className="min-w-0 max-w-full sm:flex-1 sm:basis-72">
        <Title {...titleProps} className={cn('break-words text-xl/tight font-black tracking-tight text-text-primary sm:text-2xl', titleClassName, titleProps?.className)}>
          {title}
        </Title>
        {description && (
          <div className="text-xs font-medium text-pretty text-text-secondary sm:text-sm">
            {description}
          </div>
        )}
      </div>
      {actions ? <div className="w-full self-start sm:w-auto sm:self-auto">{actions}</div> : null}
    </div>
  );
}
